import React from 'react';
import { useRouteMatch } from 'react-router';

import { BlockServiceOrdem } from 'pages/Private/StockSales/BlockServiceOrdem';

import { Route } from '../Route';

export const StockSalesRoutes = () => {
  const { url } = useRouteMatch();
  return (
    <>
      <Route isPrivate path={`${url}/block-service-ordem`} component={BlockServiceOrdem} />
    </>
  );
};
